import { ObjectExt } from '../../util';
export const filter = {
  qualify: ObjectExt.isPlainObject,
  set(filter, _ref) {
    let view = _ref.view;
    return `url(#${view.graph.defineFilter(filter)})`;
  }
};